module.exports = new __parcel__URL__("Cleaning_facility.b099d7b4.jpg").toString();